export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game-galaxsys.vue?vue&type=template&id=15774ebd&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-galaxsys.vue?vue&type=template&id=15774ebd&scoped=true
// module id = DTnA
// module chunks = 0